import { render, staticRenderFns } from "./DialogConfirmationPlayerFinal.vue?vue&type=template&id=9063e5dc&scoped=true&"
import script from "./DialogConfirmationPlayerFinal.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmationPlayerFinal.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmationPlayerFinal.vue?vue&type=style&index=0&id=9063e5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9063e5dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDialog,
  VLayout,
})
